import { Icon, Menu, MenuButton, MenuItem, MenuList, Button } from '@chakra-ui/react';
import { ChevronDown } from 'lucide-react';
import { Trans } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export function ProviderCausesDatesFilter() {
  const [selectedPreset, setSelectedPreset] = useState<string>('Select date range');
  const [searchParams, setSearchParams] = useSearchParams();

  const setDateRangeFromPast = useCallback(
    (days: number, presetLabel: string) => {
      setSelectedPreset(presetLabel);

      const params = Object.fromEntries(searchParams.entries());
      params['dateRange'] = days.toString();
      setSearchParams(new URLSearchParams(params));
    },
    [searchParams, setSearchParams],
  );

  const setAllTimes = useCallback(() => {
    setSelectedPreset('All times');

    const params = Object.fromEntries(searchParams.entries());
    delete params['dateRange'];
    setSearchParams(new URLSearchParams(params));
  }, [searchParams, setSearchParams]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        size="sm"
        variant="outline"
        px={2}
        colorScheme="gray"
        fontSize="sm"
        fontWeight="normal"
        rightIcon={<Icon as={ChevronDown} boxSize={4} />}
      >
        {selectedPreset}
      </MenuButton>
      <MenuList>
        <MenuItem onClick={() => setDateRangeFromPast(90, 'Last 3 months')}>
          <Trans>Last 3 months</Trans>
        </MenuItem>
        <MenuItem onClick={() => setDateRangeFromPast(180, 'Last 6 months')}>
          <Trans>Last 6 months</Trans>
        </MenuItem>
        <MenuItem onClick={() => setDateRangeFromPast(365, 'Last 12 months')}>
          <Trans>Last 12 months</Trans>
        </MenuItem>
        <MenuItem onClick={setAllTimes}>
          <Trans>All times</Trans>
        </MenuItem>
      </MenuList>
    </Menu>
  );
}
